import { CiViewTable, CiMap } from 'react-icons/ci';
import { Link } from 'react-router-dom';
import { MdOutlineAdd } from 'react-icons/md';
import { useState } from 'react';
import SideForm from './components/SideForm';

let Navigation = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedGurudwara, setSelectedGurudwara] = useState(null);

  const openDrawerWithHash = () => {
    window.location.hash = 'add-gurudwara';
    setDrawerOpen(true);
  };
  const closeDrawer = () => {
    window.history.replaceState(null, '', window.location.pathname);
    setDrawerOpen(false);
  };
  return (
    <div className="sidenav">
      <Link to="/">
        <CiMap />
      </Link>
      <Link to="/table">
        <CiViewTable />
      </Link>
      <Link to="#addgurudwara" onClick={openDrawerWithHash}>
        <MdOutlineAdd />
      </Link>
      <SideForm
        title={"Add Gurudwara"}
        isOpen={drawerOpen}
        toggleDrawer={closeDrawer}
        selectedData={selectedGurudwara}
        onSave={(updatedData) => console.log(updatedData)}
      />
    </div>
  );
};

export default Navigation;
